import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MatInput } from '@angular/material/input';
import { debounceTime, skip } from 'rxjs/operators';

@Component({
  selector: 'app-installation-search',
  templateUrl: './installation-search.component.html',
  styleUrls: ['./installation-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallationSearchComponent implements AfterViewInit {
  private debounce = 300;

  @ViewChild(MatInput, { static: true }) input: MatInput;

  @Input() searchTerm: string;
  @Input() categoryForGtm: string;
  @Input() disabled = false;

  @Output() search: EventEmitter<string> = new EventEmitter<string>();
  @Output() clear: EventEmitter<void> = new EventEmitter<void>();

  ngAfterViewInit(): void {
    this.input.ngControl.valueChanges
      .pipe(
        debounceTime(this.debounce),
        skip(1) // skip first change when value is set to undefined
      )
      .subscribe((value: string) => {
        this.searchTermChanged(value);
      });
  }

  focus(): void {
    this.input.focus();
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.clear.emit(undefined);
  }

  searchTermChanged(value: string): void {
    this.search.emit(value);
  }
}
